import React from 'react'

const  TermsOfUse=(props:any)=> {
    return (
        <div className="TermsOfUse-background">
        <div className="container">
          <div dangerouslySetInnerHTML={{ __html: props.data.description }} />
        </div>
      </div>
    )
}

export default TermsOfUse
